import React from 'react';
import './WorkerIcons.css';
import WORKER_TEMPLATES from '../config/workerTemplates';

export default function WorkerIcons({ stakedWorkers = [], onSelect, currentTab, setTab }) {
  const workerIcons = stakedWorkers
    .map(worker => {
      const matched = WORKER_TEMPLATES.find(w => w.template_id === parseInt(worker.template_id));
      return matched ? { ...worker, img: matched.img_worker } : null;
    })
    .filter(Boolean)
    .slice(0, 6); // sadece ilk 6 taneyi al

  return (
    <div className="worker-icons-grid">
      {workerIcons.map((worker, i) => (
        <img
          key={i}
          src={worker.img}
          alt="worker"
          className="worker-icon"
          onClick={() => {
            onSelect?.(worker);
            if (currentTab !== 'home') setTab?.('home');
          }}
        />
      ))}
    </div>
  );
}
